module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [(_vm.certificationProcess.areas[this.activeArea].status <= 1) ? _c('md-layout', {
    key: "syncInformations"
  }, [(_vm.queueStatus === 'creating') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("CARREGANDO INFORMAÇÕES")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Nesta etapa você precisa manter o WI-FI do seu celular ligado\n        até que o envio esteja concluído.")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.queueLog))]), _vm._v(" "), _c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : (_vm.queueStatus === 'waiting') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("ENVIO DAS FOTOS PARA NUVEM")]), _vm._v(" "), _c('span', [_vm._v("Esta é uma etapa do processo que visa enviar as fotos para nuvem e liberar espaço na memória do aparelho. ")]), _vm._v(" "), _c('p', [_vm._v("Seu processo "), _c('b', [_vm._v("NÃO SERÁ CONCLUÍDO")]), _vm._v(" nesse momento, após finalizar a sincronização você poderá continuar\n        normalmente.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    attrs: {
      "disabled": !_vm.networkStatus
    },
    on: {
      "click": _vm.startQueue
    }
  }, [_vm._v("Iniciar a Sincronização\n      ")])], 1) : (_vm.queueStatus === 'running') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("ENVIANDO FOTOS PARA NUVEM")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Durante esse processo mantenha o aplicativo aberto e WI-FI\n        ligado.")]), _vm._v(" "), _c('md-progress', {
    staticClass: "md-warn",
    attrs: {
      "md-size": 150,
      "md-progress": _vm.progress
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.queueLog) + "\n        Total: " + _vm._s(_vm.queue.size) + " Pendente: " + _vm._s(_vm.queue.pending)), _c('br'), _vm._v("\n        Area Atual: " + _vm._s(_vm.currentArea)), _c('br'), _vm._v("\n        Item Atual: " + _vm._s(_vm.currentItem)), _c('br'), _vm._v("\n        Foto Atual: " + _vm._s(_vm.currentPhoto) + "\n      ")])], 1) : _vm._e()], 1) : _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("SINCRONIZAÇÃO DA ÁREA "), _c('b', [_vm._v(_vm._s(_vm.currentArea))]), _vm._v(" EFETUADA COM SUCESSO!\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("As fotos foram liberadas da memória, continue com seu processo de\n      certificação.")])]), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": Infinity
    }
  }, [_c('span', [_vm._v("Sem conexão com a internet! Conecte a uma rede wi-fi e tente\n      novamente.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cc516c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SyncAreaPhotos.vue
// module id = 833
// module chunks = 1